import * as React from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import PostAddIcon from '@mui/icons-material/PostAdd';
import { useNavigate } from "react-router-dom";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import { User } from "../../Models/User";

import colors from "../../theme/colors";
import Item from "../Shared/Style/StyledItem";

export default function Estoque(){

    const navigate = useNavigate();
    const rawUser = sessionStorage.getItem("User");
    const user: User | null = rawUser ? JSON.parse(rawUser) : null;
    const isAdm = user?.papel === "Administrador";
  
    const NavigateTo = (path: string) => {
      navigate(path);
    }
    
    return(
      <Box sx={{ flexGrow: 1, p: 2, height: '90vh', display: 'flex', flexDirection: 'column' }}>
      <Paper sx={{ p: 2, height: '100%', display: 'flex', flexDirection: 'column' }}>
          <Grid container spacing={2}>
            {/* Linha 1 - Cabeçalho e Descrição */}
            <Grid item xs={12}> 
              <Paper sx={{ p: 1, bgcolor: '#f8f9fa' }}>
                <h4 style={{ margin: '0 0 0 0', color: colors.bluePrimary, textAlign: 'left' }}>
                  📦 Gestão de Estoque
                </h4>
                <Typography variant="body2" sx={{ color: '#666', mt: 1 }}>
                  Controle e gerenciamento do estoque
                </Typography>
              </Paper>
            </Grid>

            {/* Linha 2 - Cards de Navegação */}
            <Grid item xs={12}>
              <Grid container spacing={2}>
                {/* Card - Gestão de Itens */}
                <Grid item xs={12} sm={6} md={6}>
                  <Item onClick={() => NavigateTo("../gerenciarestoque")}>
                    <Box sx={{ 
                      display: 'flex', 
                      flexDirection: 'column', 
                      alignItems: 'center',
                      p: 1
                    }}>
                      <PostAddIcon
                        sx={{ 
                          color: colors.accent, 
                          fontSize: '2.5em',
                          mb: 1
                        }}
                      />
                      <Typography variant="h6" sx={{ color: colors.bluePrimary, fontWeight: 'bold', mb: 1 }}>
                        Gestão de Itens
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#666', textAlign: 'center' }}>
                        Controle completo do estoque
                      </Typography>
                    </Box>
                  </Item>
                </Grid>
                <Grid item xs={12} sm={6} md={6} sx={{ display: isAdm ? "flex" : "none" }}>
                  <Item onClick={() => NavigateTo("../compras")}>
                    <Box
                      sx={{
                        display: isAdm ? "flex" : "none",
                        flexDirection: "column",
                        alignItems: "center",
                        p: 1,
                      }}
                    >
                      <ShoppingCartIcon
                        sx={{
                          color: colors.accent,
                          fontSize: "2.5em",
                          mb: 1,
                        }}
                      />
                      <Typography
                        variant="h6"
                        sx={{ color: colors.bluePrimary, fontWeight: "bold", mb: 1 }}
                      >
                        Compras
                      </Typography>
                      <Typography variant="body2" sx={{ color: "#666", textAlign: "center" }}>
                        Registrar compras e incluir produtos
                      </Typography>
                    </Box>
                  </Item>
                </Grid>

                {/* Card - Consultar Estoque (Placeholder para futuro) 
                <Grid item xs={12} sm={6} md={6}>
                  <Item>
                    <Box sx={{ 
                      display: 'flex', 
                      flexDirection: 'column', 
                      alignItems: 'center',
                      p: 1,
                      opacity: 0.6
                    }}>
                      <Box sx={{ 
                        width: '4em', 
                        height: '4em', 
                        bgcolor: '#e0e0e0', 
                        borderRadius: '50%',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        mb: 1
                      }}>
                        <Typography variant="h4" sx={{ color: '#999' }}>
                          🔍
                        </Typography>
                      </Box>
                      <Typography variant="h6" sx={{ color: '#999', fontWeight: 'bold', mb: 1 }}>
                        Consultar Estoque
                      </Typography>
                      <Typography variant="body2" sx={{ color: '#999', textAlign: 'center' }}>
                        Em desenvolvimento
                      </Typography>
                    </Box>
                  </Item>
                </Grid>
                */}
              </Grid>
            </Grid>
          </Grid>
        </Paper>
      </Box>
    )
}